export const SUCCESS = true;
export const FAILED = false;
export const UNSET = null;

export const GET_USERS = "GET_USERS";
export const API_ERROR = "API_ERROR";
export const API_UNAUTHORIZED = "API_UNAUTHORIZED";

export const LOADING_START = "LOADING_START";
export const LOADING_SUCCESS = "LOADING_SUCCESS";
export const LOADING_FAIL = "LOADING_FAIL";

export const ON_LOGO_CLICK = "ON_LOGO_CLICK";

export const ON_CHECK_TOKEN = "ON_CHECK_TOKEN";
export const SET_TOKEN_STATUS = "SET_TOKEN_STATUS";

export const DISMISS_ERROR = "DISMISS_ERROR";
export const ON_ERROR = "ON_ERROR";
export const RESET_STATUS = "RESET_STATUS";

//Authentication
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_RESET = "AUTH_RESET";

export const SET_SPLASH_WAIT = "[internal process] SET_SPLASH_WAIT";
export const RESET_SPLASH_WAIT = "[internal process] RESET_SPLASH_WAIT";

export const TOGGGLE_OCCUPIER = "[internal process] TOGGGLE_OCCUPIER";

export const ON_NEED_LOGIN_POPUP = "[internal process] ON_NEED_LOGIN_POPUP";
export const ON_CANCEL_AUTHENTICATION = "[internal process] ON_CANCEL_AUTHENTICATION";
export const ON_SELECT_UPDATE_CATEG = "[internal process] ON_SELECT_UPDATE_CATEG";
export const ON_CANCEL_UPDATE_CATEG = "[internal process] ON_CANCEL_UPDATE_CATEG";
export const ON_CLOSE_FEEDBACK = "[internal process] ON_CLOSE_FEEDBACK";

export const API_EMAIL_VALIDATION_START = "[api request] EMAIL_VALIDATION_START"
export const API_EMAIL_VALIDATION_SUCCESS = "[api request] EMAIL_VALIDATION_SUCCESS"
export const API_EMAIL_VALIDATION_FAIL = "[api request] EMAIL_VALIDATION_FAIL"
export const API_MOBILE_VALIDATION_START = "[api request] MOBILE_VALIDATION_START"
export const API_MOBILE_VALIDATION_SUCCESS = "[api request] MOBILE_VALIDATION_SUCCESS"
export const API_MOBILE_VALIDATION_FAIL = "[api request] MOBILE_VALIDATION_FAIL"
export const VALID_STATUS_EMAIL = "[internal process] VALID_STATUS_EMAIL"
export const VALID_STATUS_MOBILE = "[internal process] VALID_STATUS_MOBILE"

export const SET_STATE = "[internal process] SET_STATE"

export const API_GET_TNC_START = "[api request] GET_TNC_START"
export const API_GET_TNC_SUCCESS = "[api request] GET_TNC_SUCCESS"
export const API_GET_TNC_FAIL = "[api request] GET_TNC_FAIL"
